export default __webpack_public_path__ + "static/media/js.acc4642f.svg";